// @flow
import React from 'react';
import classNames from 'classnames/bind';
import VisibilitySensor from 'react-visibility-sensor';
import { useTranslation } from 'react-i18next';

import Bill from 'app/components/Bill';
import Picture from 'app/common/ui-next/picture';
import PlainLinkAsButton from 'app/common/ui-next/plain-link-as-button';
import IconBtnGo from 'app/components/_Icons/IconBtnGo';
import Tooltip from 'app/common/ui/Tooltip';

import AppIcon from '../../AppIcon';
import styles from './Event.scss';


const cx = classNames.bind(styles);

type Props = {
  id: number,
  string: string,
  text: string,
  time: ?string,
  isViewed: boolean,
  billPdfUrl: ?string,
  iconUrl: ?string,
  moreUrl: ?string,
  handleAppear: (id: number) => void,
}

const Event = ({
  id,
  string,
  text,
  time = '',
  isViewed,
  billPdfUrl = '',
  iconUrl,
  moreUrl,
  handleAppear,
}: Props) => {
  const { t } = useTranslation('events');

  return (
    <VisibilitySensor
      onChange={isVisible => !isViewed && isVisible && handleAppear(id)}
      intervalDelay={2000}
      scrollDelay={2000}
      scrollCheck
      delayedCall
    >
      <div className={cx({ root: true, isViewed })}>
        <div className={styles.icon}>
          {iconUrl
            ? <Picture alt={text} src={iconUrl} width="32px" />
            : <AppIcon string={string} />}
        </div>
        <div
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: text }} // eslint-disable-line react/no-danger
        />
        {moreUrl
          && <div className={styles.btnMoreContainer}>
            <PlainLinkAsButton
              to={moreUrl}
              className={styles.btnMore}
            >
              {t('event_btn_more_title')}
              <IconBtnGo className={styles.btnMoreIcon} />
            </PlainLinkAsButton>
          </div>}
        <div className={styles.bill}>
          <Tooltip text={t('bill_tooltip')}>
            <Bill link={billPdfUrl} />
          </Tooltip>
        </div>
        <div className={styles.time}>{time}</div>
      </div>
    </VisibilitySensor>
  );
};

export default Event;
